<template>
  <div class="page_content explore_entity_inside program degree_req pg_cn__degree_req" aria-label="Program Guide Degree Requirements">

      <div class="row page-heading">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
            <span class="module_icon  icon-list"></span>
            <template v-if="formattedProgramGuide && formattedProgramGuide.title">
              <program-guide-title :program-guide="formattedProgramGuide"></program-guide-title>
            </template>
          </div>

          <template v-if="isWidget">
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 btn_container" :id="'creditProgressPopup_' + formattedProgramGuide.uuid">
              <b-btn style="width: 225px; padding: 0;" @click="calculateCreditProgressClicked(formattedProgramGuide)">
                <b-progress :max="progress.total" height="30px" style="cursor: pointer;" show-value>
                  <b-progress-bar :value="Number(selected)" style="background-color: #532a6e;"></b-progress-bar>
                  <b-progress-bar :value="progress.completed" style="background-color: #508002;"></b-progress-bar>
                  <b-progress-bar :value="progress.notPlanned - selected" style="background-color: #cf7908;"></b-progress-bar>
                </b-progress>
              </b-btn>
            </div>
          </template>
          <template v-else>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 btn_container" v-if="showBackToResultButton">
              <b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
                <span class="btn_ic ic-back"></span>
                <span class="btn_txt">{{ deCamelCase() }}</span>
              </b-btn>
              <span v-if="showAddCompletedCoursesOnResult">
                <b-button @click="addCompletedCourses" aria-label="add completed courses">Add Completed Courses</b-button>
              </span>
              <span class="lnk_req_credit"
                v-if="showCalculateRequiredCredit && isStudentLogin && planningStream" :id="'creditProgressPopup_' + formattedProgramGuide.uuid"
                @click="calculateCreditProgressClicked(formattedProgramGuide)">
                <template v-if="isShowCourseProgressEnabled">
                  <template v-if="showTransferredCoursesCreditProgress">
                    <div style="border: 1px solid #157099; margin: -3px -15px; font-size: 18px;">
                      <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{progress.transferredCourses}} out of {{progress.totalCourses}} courses</span>
                    </div>
                  </template>
                  <template v-else>
                    <b-btn style="width: 225px; padding: 0;">
                      <b-progress :max="progress.totalCourses" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                        <b-progress-bar :value="progress.transferredCourses" :precision="setPrecision(progress.transferredCourses)" style="background-color: #57b6e6;"></b-progress-bar>
                        <b-progress-bar :value="progress.completedCourses" :precision="setPrecision(progress.completedCourses)" style="background-color: #508002;"></b-progress-bar>
                        <b-progress-bar :value="progress.inProgressCourses" :precision="setPrecision(progress.inProgressCourses)" style="background-color: #9ec758;"></b-progress-bar>
                        <b-progress-bar :value="progress.notStartedCourses" :precision="setPrecision(progress.notStartedCourses)" style="background-color: #f5b318;"></b-progress-bar>
                        <b-progress-bar :value="progress.notPlannedCourses" :precision="setPrecision(progress.notPlannedCourses)" style="background-color: #cf7908;"></b-progress-bar>
                      </b-progress>
                    </b-btn>
                  </template>
                </template>
                <template v-else>
                  <template v-if="showTransferredCoursesCreditProgress">
                    <div class="float-left" style="border: 1px solid #157099; margin: -3px -15px; font-size: 18px;">
                      <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{progress.transfered}} out of {{progress.total}} credits</span>
                    </div>
                  </template>
                  <template v-else>
                    <b-btn style="width: 225px; padding: 0;">
                      <b-progress :max="progress.total" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                        <b-progress-bar :value="progress.transfered" :precision="setPrecision(progress.transfered)" style="background-color: #57b6e6;"></b-progress-bar>
                        <b-progress-bar :value="progress.completed" :precision="setPrecision(progress.completed)" style="background-color: #508002;"></b-progress-bar>
                        <b-progress-bar :value="progress.inProgress" :precision="setPrecision(progress.inProgress)" style="background-color: #9ec758;"></b-progress-bar>
                        <b-progress-bar :value="progress.notStarted" :precision="setPrecision(progress.notStarted)" style="background-color: #f5b318;"></b-progress-bar>
                        <b-progress-bar :value="progress.notPlanned" :precision="setPrecision(progress.notPlanned)" style="background-color: #cf7908;"></b-progress-bar>
                      </b-progress>
                    </b-btn>
                  </template>
                </template>
              </span>
            </div>
          </template>
      </div>


      <div class="page_content_container">

        <div v-if="formattedProgramGuide && formattedProgramGuide.title">
          <program-guide-menu
                :cipCode="formattedProgramGuide.cipCode"
                :programGuideCode="formattedProgramGuide.code"
                :type="formattedProgramGuide.type"
                :returnTo="returnTo"
                :showBackToResultButton="showBackToResultButton"
                :active="'degreeRequirements'"
                :isWidget="isWidget"
                :selected="selected">
            </program-guide-menu>
        </div>

        <div class="row pg_content">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

            <div class="tabs_panel">
              <b-tabs>
                <b-tab :title="getCoursesLabel()" active @click="showTab('COURSES')" v-if="formattedProgramGuide.categories.length > 0">
                  <template v-if="showCourses">
                    <program-courses ref="programCourse" :pathway-id="formattedProgramGuide.uuid"></program-courses>
                  </template>
                </b-tab>
                <b-tab :title="getPrerequisiteLabel()" @click="showTab('PREREQUISITE')" v-if="educationReqs.length > 0">
                  <template v-if="showPrerequisite">
                    <program-education ref="programEducation" :pathway-id="formattedProgramGuide.uuid"></program-education>
                  </template>
                </b-tab>
                <b-tab :title="getCocurricularLabel()" @click="showTab('COCURRICULAR')" v-if="cocurricularReqs.length > 0">
                  <template v-if="showCoCurricular">
                    <program-cocurricular ref="programCocurricular" :pathway-id="formattedProgramGuide.uuid"></program-cocurricular>
                  </template>
                </b-tab>
              </b-tabs>
            </div>

          </div> <!-- .content_mid_panel -->
        </div> <!-- .pg_content -->

          <!--
          <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 content_rgt_panel">

            <div v-if="formattedProgramGuide && formattedProgramGuide.cipCode">
                <program-guide-summary></program-guide-summary>

                <program-guide-recommendations
                  :cipCode="formattedProgramGuide.cipCode"
                  :programGuideCode="formattedProgramGuide.code"
                  :type="formattedProgramGuide.type"
                  :returnTo="returnTo"
                  :showBookmarks="true">
                </program-guide-recommendations>
              </div>

          </div>
          -->
          <!-- .content_rgt_panel -->

          <template v-if="showCreditProgressPopup">
            <explore-program-credit-progress
                :title="selectedProgramGuide.title"
                :stream-id="planningStream.uuid"
                :program-id="selectedProgramGuide.uuid"
                :credit-progress-target-id="creditProgressTargetId"
                :is-widget="isWidget"
                :selected="Number(selected)">
            </explore-program-credit-progress>
          </template>

    </div> <!-- .page_content_container -->


    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
        </div>
      </b-modal>
    </div>


  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideTitle from './ProgramGuideTitle'
import ProgramGuideRecommendations from './ProgramGuideRecommendations'
import ProgramGuideSummary from './ProgramGuideSummary'
import ExploreProgramCreditProgress from '../../explore/components/ExploreProgramCreditProgress'
import ProgramCourses from '../../transfer/components/ProgramCourses'
import ProgramEducation from '../../transfer/components/ProgramEducation'
import ProgramCocurricular from '../../transfer/components/ProgramCocurricular'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'program-guide-degree-requirements',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'showBackToResultButton', 'isWidget', 'selected', 'loadDataFromServer', 'isExpandTransferredCourses'],
  components: {
    ProgramGuideMenu,
    ProgramGuideTitle,
    ProgramGuideRecommendations,
    ProgramGuideSummary,
    ExploreProgramCreditProgress,
    ProgramCourses,
    ProgramEducation,
    ProgramCocurricular
  },
  data: () => {
    return {
      RECOMMENDATION_TERM_LIMIT: 5,
      DEFAULT_TYPE: 'MAJOR',
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      selectedProgramGuide: null,
      creditProgressTargetId: '',
      showCreditProgressPopup: false,
      showCourses: true,
      showCoCurricular: false,
      showPrerequisite: false,
      educationReqs: [],
      cocurricularReqs: [],
      progress: {}
    }
  },

  async created () {
    let pathwayId = this.formattedProgramGuide.uuid
    this.educationReqs = await this.loadProgramEducation(pathwayId)
    this.cocurricularReqs = await this.loadProgramCocurricular(pathwayId)
  },

  mounted () {
    this.loadDataForProgramGuideDegreeRequirements()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers',
      'loadLogDashboardActivity',
      'loadProgramCreditProgress',
      'loadProgramEducation',
      'loadProgramCocurricular'
    ]),
    addCompletedCourses () {
      return this.$router.push({name: 'selfReportedCourseList'})
    },
    setPrecision (n) {
      if (Number(n) === n && n % 1 !== 0) {
        return 1
      }
      return 0
    },
    showTab (tab) {
      this.showCourses=false
      this.showCoCurricular=false
      this.showPrerequisite=false
      if(tab && tab==='PREREQUISITE'){
        this.showPrerequisite = true
      }else if(tab && tab==='COCURRICULAR'){
        this.showCoCurricular = true
      } else{
        this.showCourses = true
      }
    },
    async loadDataForProgramGuideDegreeRequirements () {
      let cipCode = this.cipCode
      let programGuideCode = this.programGuideCode
      let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
      if (!cipCode || !programGuideCode) {
        return this.$router.push({ name: returnTo })
      }
      let programGuide = await this.loadProgramGuide({
        cipCode: cipCode,
        programGuideCode: programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
      if (!programGuide || !programGuide.cipCode) {
        return this.$router.push({ name: returnTo })
      }
      // load credit progress
      this.progress = await this.loadProgramCreditProgress({streamId: this.planningStream.uuid, programId: programGuide.uuid, recalculate: false})
      // load related career information, if any exists
      await this.loadProgramGuideCareers({ cipCode: programGuide.cipCode, code: programGuide.code, showAllOccupations: true })
      this.loadLogDashboardActivity({action: 'viewProgramDegreeRequirements', page: 'programDegreeRequirements', link: '', programCipCode: cipCode})
      this.bindClickEventOnSubCategory()
      if (this.isExpandTransferredCourses) {
        $('#transferred').click()
      }
    },
    returnToClicked () {
    if (this.returnTo === 'relatedPrograms') {
        let routerParams = JSON.parse(localStore.getItem('returnRouterParams'))
        localStore.removeItem('returnRouterParams')
        return this.$router.push({ name: 'programGuideRelatedProgram', params: routerParams, query: {returnTo: routerParams.returnTo} })
      }
      return this.$router.push({ name: this.returnTo })
    },
    bindClickEventOnSubCategory () {
      let parentElem = this.$refs['reqParentDiv']
      let elems = $(parentElem).find('.pg_sec_head')
      if (elems && elems.length > 0) {
        for (let i = 0; i < elems.length; i++) {
          let elem = elems[i]
          let reqCode = $(elem).attr('id')
          $(elem).first().click(() => {
            this.updatePageSecCssClass(reqCode)
          })
        }
      }
    },
    updatePageSecCssClass (pgSectionId) {
      let isActiveClass = $('#accordionCrdContent_' + pgSectionId).hasClass('active')
      if (isActiveClass) {
        $('#' + pgSectionId).removeClass('active')
        $('#accordionCrdContent_' + pgSectionId).removeClass('active')
        $('#accordionCrdContent_' + pgSectionId).css('display', 'none')
      } else {
        $('#' + pgSectionId).addClass('active')
        $('#accordionCrdContent_' + pgSectionId).addClass('active')
        $('#accordionCrdContent_' + pgSectionId).css('display', 'block')
      }
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return 'return to ' + result
    },
    getCoursePlanningPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getCoursePlanningPackage(packages)
    },
    calculateCreditProgressClicked (programGuide) {
      this.selectedProgramGuide = programGuide
      this.creditProgressTargetId = 'creditProgressPopup_' + programGuide.uuid
      this.showCreditProgressPopup = true
    },
    getCocurricularLabel () {
      if(this.formattedProgramGuide.cocurricularRequirement && this.formattedProgramGuide.cocurricularRequirement.length>0 && this.formattedProgramGuide.cocurricularRequirement[0].tabLabel) {
        return this.formattedProgramGuide.cocurricularRequirement[0].tabLabel
      }
      return 'Co-Curricular'
    },
    getPrerequisiteLabel () {
      if(this.formattedProgramGuide.educationRequirement && this.formattedProgramGuide.educationRequirement.length>0 && this.formattedProgramGuide.educationRequirement[0].tabLabel) {
        return this.formattedProgramGuide.educationRequirement[0].tabLabel
      }
      return 'Prerequisite'
    },
    getCoursesLabel () {
      if(this.formattedProgramGuide.categories && this.formattedProgramGuide.categories.length>0 && this.formattedProgramGuide.categories[0].tabLabel) {
        return this.formattedProgramGuide.categories[0].tabLabel
      }
      return 'Courses'
    },

    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    }
  },
  computed: {
    ...mapState({
      'programGuideObject': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'packages': state => state.institution.packages,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'planningStream': state => state.dashboard.planningStream
    }),
    creditLabel () {
      let creditLabelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CREDIT_LABEL_FEATURE_ID]
      if (!creditLabelFeature || !creditLabelFeature.enabled || !creditLabelFeature.label) {
        return 'Credit'
      }
      return creditLabelFeature.label
    },
    showTransferredCourses () {
      let transferCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TRANSFER_PREVIOUS_COURSES_FEATURE_ID]
      if (transferCoursesFeature && transferCoursesFeature.enabled) {
        let flags = transferCoursesFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'showTransferredCoursesOnDegreeRequirement') {
            return flag.enabled
          }
        }
      }
      return false
    },
    transferredCoursesLabel () {
      let lable = 'Transferred Courses'
      let transferCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TRANSFER_PREVIOUS_COURSES_FEATURE_ID]
      if (transferCoursesFeature && transferCoursesFeature.enabled) {
        let flags = transferCoursesFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if ((flag.title === 'showTransferredCoursesOnDegreeRequirement') && flag.label.length > 0) {
            lable = flag.label
          }
        }
      }
      return lable
    },
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuideObject
      return formattedProgramGuide
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      return formattedCareers
    },
    showCatalogSource () {
      let catalogSourceFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_CATALOG_SOURCE]
      return catalogSourceFeature && catalogSourceFeature.enabled
    },
    catalogSourceLabel () {
      let catalogSourceFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_CATALOG_SOURCE]
      if (catalogSourceFeature && catalogSourceFeature.label) {
        return catalogSourceFeature.label
      } else {
        return ''
      }
    },
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    exploreProgramsFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    },
    showTransferredCoursesCreditProgress () {
      let transferCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TRANSFER_PREVIOUS_COURSES_FEATURE_ID]
      if (transferCoursesFeature && transferCoursesFeature.enabled) {
        let flags = transferCoursesFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'showTransferredCoursesCreditProgress') {
            return flag.enabled
          }
        }
      }
      return false
    },
    showCalculateRequiredCredit () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultCalculateRequiredCredit) {
        return false
      }
      return exploreProgramsFlagMap.searchResultCalculateRequiredCredit.enabled
    },
    isShowCourseProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgress' || flags[i].title === 'showCourseProgressOnOverall') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowCreditProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCreditProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isStudentLogin () {
      return (localStorage.getItem('userrole') === 'Student')
    }
  },
  showCocurricularTab () {
    if(this.formattedProgramGuide.cocurricularRequirement && this.formattedProgramGuide.cocurricularRequirement.length>0) {
      return true
    }
    return false
  },
  showPrerequisiteTab () {
    if(this.formattedProgramGuide.eduacationRequirement && this.formattedProgramGuide.eduacationRequirement.length>0) {
      return true
    }
    return false
  },
  showCourseTab () {
    return this.showCocurricularTab() || this.showPrerequisiteTab()
  },

  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideDegreeRequirements.vue